
import MyNavbar from '../../../components/customer/MyNavbar';
import PackagesHero from '../../../screens/customer/packages/PackagesHero';
import Weddingpriceguide from '../../../screens/customer/packages/Weddingpriceguide';

import Footer from '../../../components/customer/Footer';

const Packages = () => {
  return (
    <>
    <MyNavbar />
  <PackagesHero />
  <Weddingpriceguide />
  
   <Footer />
    </>
  );
};

export default Packages;



